/*
  テクノロジーページのファーストビュー（SPの開閉）

  実装仕様
  #1 JSが要るのはSPだけ。PCはホバーで開くのでCSSだけで完結する
  #2 1回目のタップで開き、開いている帯をもう一度タップすると飛ぶ。
     1回目で飛ばすと、中身を見ないまま移動することになるため
  #3 開いたら横に送って左端に寄せる。帯は画面からはみ出して並んでいるので、
     開いた帯が画面の外に居ることがある
  #4 同時に開くのは1枚。PCのホバーと同じ決まりにする
  #5 画面幅がPCに変わったら開いた状態を捨てる。
     CSSの担当がホバーに切り替わり、JSが付けた状態と食い違うため
  #6 JSが読めなかった場合はタップがそのままリンクとして働く。
     開かないだけで飛び先には行ける

  見出しの塗り分け（PCのみ）
  #7 見出し本体は紺。白地の上ではそれで読めるが、帯（写真）の上では沈む。
     白い複製を重ね、帯に覆われている範囲だけを見せるマスクを当てる。
     CSSからは帯の座標が分からないのでJSで作る
  #7b 開いているかどうかは関係ない。**幅が狭いと待機中でも帯に重なる**ので、
     ホバーを条件にすると待機中に読めなくなる。地の色だけで決める
  #7c 白くするのは**暗い画像の帯だけ**。明るい画像の帯では白文字も消えるので、
     画像の明るさを実際に測って決める。測るのは画像の上の帯
     （見出しが乗るのは帯の上のほう）。1枚につき1回だけ測って覚えておく。
     画像が無い帯（プレースホルダー）は明るい扱いにする
  #8 帯は開閉で幅が変わる。動いているあいだは毎フレーム作り直し、
     止まったら更新も止める。常時回さないのは、止まっている間まで
     計算し続ける理由がないため
  #9 重なりが無いときは複製を出さない

  ファーストビューを抜ける送り（PCのみ）
  #10 ファーストビューが画面に残っているあいだに下へホイールを回すと、
     次のセクション（最初の技術の詳細）の上端まで一気に送る（2026年9月29日 PM指定
     「スクロールでファーストビューが消えて、下のコンテンツが現れる」）。
     詳細の上端から上へ回したときは頂上へ戻す。それ以外は普通のスクロール
  #11 送りは Lenis があれば Lenis で、同じ慣性の質感で動かす（window.cSmoothScroll）。
     無ければ素の滑らかな移動。長さは --motion-duration、イージングは out 系
  #12 送っているあいだと着いた直後のホイールは捨てる。トラックパッドの慣性で
     続けて届く分を拾うと、着いたそばから先へ流れる
  #13 Lenis より先にホイールを受け取るため、window に capture で付けて伝播を止める。
     メニューの面・ダイアログの上、Focal のポップアップが開いているあいだ（lock all）、
     動きを減らす設定・タッチ・1000px未満では何もしない
*/
(function () {
  'use strict';

  var SMALL = window.matchMedia('(max-width: 740px)');
  var PASS = window.matchMedia('(min-width: 1000px) and (pointer: fine)');
  /* 着いた直後のホイールを捨てる時間。実装仕様 #12 */
  var PASS_HOLD = 250;
  var LARGE = window.matchMedia('(min-width: 741px)');
  var MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');

  function panels(hero) {
    return Array.prototype.slice.call(hero.querySelectorAll('[data-c-tech-panel]'));
  }

  function closeAll(hero) {
    hero.removeAttribute('data-open');

    panels(hero).forEach(function (panel) {
      panel.removeAttribute('data-open');

      if (panel.hasAttribute('aria-expanded')) {
        panel.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function open(hero, panel) {
    closeAll(hero);
    hero.setAttribute('data-open', '');
    panel.setAttribute('data-open', '');
    panel.setAttribute('aria-expanded', 'true');

    panel.scrollIntoView({
      inline: 'start',
      block: 'nearest',
      behavior: MOTION.matches ? 'auto' : 'smooth'
    });
  }

  /*
    帯が暗いか（実装仕様 #7c）

    明るさの測り方は assets/custom luminance.js が持つ（サイト共通）。
    ここが決めるのは「どの絵の、どこを見るか」だけ。
    見出しが乗るのは帯の上のほうなので、上から4分の1を見る
  */
  function isDark(panel, hero) {
    var lum = window.cLuminance;
    var img = panel.querySelector('img');

    /* 画像が無い（プレースホルダー）は明るい扱い */
    if (!lum || !img) {
      return false;
    }

    var src = img.currentSrc || img.src;

    if (!src) {
      return false;
    }

    var table = lum.known(src);

    /* まだ測れていない。測ってから塗り直す（この回は明るい扱いで返す） */
    if (!table) {
      lum.grid(src, function () {
        paintLabel(hero);
      });

      return false;
    }

    return lum.average(table, 0, 0, 1, 0.25) < lum.LIGHT_LIMIT;
  }

  /*
    見出しの塗り分け。実装仕様 #7〜#9
  */
  function paintLabel(hero) {
    var label = hero.querySelector('[data-c-tech-label]');
    var copy = hero.querySelector('[data-c-tech-label-over]');

    if (!label || !copy) {
      return 'off';
    }

    if (!LARGE.matches) {
      copy.removeAttribute('data-active');
      return 'off';
    }

    var box = label.getBoundingClientRect();

    if (box.width === 0) {
      copy.removeAttribute('data-active');
      return 'off';
    }

    /* 見出しの箱の中で、帯に覆われている範囲を左からの位置で集める */
    var stops = [];

    panels(hero).forEach(function (panel) {
      if (!isDark(panel, hero)) {
        return;
      }

      var rect = panel.getBoundingClientRect();
      var from = Math.max(0, rect.left - box.left);
      var to = Math.min(box.width, rect.right - box.left);

      if (to > from) {
        stops.push([from, to]);
      }
    });

    stops.sort(function (a, b) {
      return a[0] - b[0];
    });

    /* 帯に重なっていないなら複製は要らない */
    if (stops.length === 0) {
      copy.removeAttribute('data-active');
      return 'none';
    }

    /*
      端数は丸める。生の小数のままだと、レイアウトが同じでも
      末尾の桁が揺れて「変わっていない」と判定できず、
      追いかけるのを止められない
    */
    var round = function (value) {
      return Math.round(value * 10) / 10;
    };

    var parts = ['transparent 0'];

    stops.forEach(function (range) {
      var from = round(range[0]);
      var to = round(range[1]);

      parts.push('transparent ' + from + 'px');
      parts.push('#000 ' + from + 'px');
      parts.push('#000 ' + to + 'px');
      parts.push('transparent ' + to + 'px');
    });

    var mask = 'linear-gradient(to right, ' + parts.join(', ') + ')';

    copy.style.setProperty('--c-tech-label-mask', mask);
    copy.setAttribute('data-active', '');

    return mask;
  }

  /*
    帯が動いているあいだだけ追いかける。実装仕様 #8

    止めどきは transitionend では判断しない。開閉では gap / flex grow /
    opacity / color が同時に動き、どれか1つが先に終わった時点で
    止めてしまうため。代わりに「マスクが変わらなくなったら止める」。
    何が動いていようと、結果が落ち着いたことだけを見ている
  */
  var STILL_FRAMES = 10;

  function track(hero) {
    if (hero.dataset.cTechTracking === 'true') {
      /* 動き出したので、止まりかけていたら数え直す */
      hero.dataset.cTechStill = '0';
      return;
    }

    hero.dataset.cTechTracking = 'true';
    hero.dataset.cTechStill = '0';

    var last = null;

    window.requestAnimationFrame(function step() {
      if (hero.dataset.cTechTracking !== 'true') {
        return;
      }

      var mask = paintLabel(hero);

      if (mask === last) {
        var still = (parseInt(hero.dataset.cTechStill, 10) || 0) + 1;
        hero.dataset.cTechStill = String(still);

        if (still >= STILL_FRAMES) {
          hero.dataset.cTechTracking = 'false';
          return;
        }
      } else {
        hero.dataset.cTechStill = '0';
      }

      last = mask;
      window.requestAnimationFrame(step);
    });
  }

  function watchLabel(hero) {
    if (!hero.querySelector('[data-c-tech-label-over]')) {
      return;
    }

    paintLabel(hero);

    hero.addEventListener('pointerover', function () {
      track(hero);
    });

    hero.addEventListener('pointerout', function () {
      track(hero);
    });

    hero.addEventListener('focusin', function () {
      track(hero);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        paintLabel(hero);
      }).observe(hero);
    }

    LARGE.addEventListener('change', function () {
      paintLabel(hero);
    });
  }

  function setup(root) {
    var heroes = (root || document).querySelectorAll('[data-c-tech-hero]');

    Array.prototype.forEach.call(heroes, function (hero) {
      if (hero.dataset.cTechReady === 'true') {
        return;
      }

      hero.dataset.cTechReady = 'true';

      panels(hero).forEach(function (panel) {
        panel.setAttribute('aria-expanded', 'false');
      });

      hero.addEventListener('click', function (event) {
        if (!SMALL.matches) {
          return;
        }

        var panel = event.target.closest('[data-c-tech-panel]');

        if (!panel || !hero.contains(panel)) {
          return;
        }

        /* 開いている帯は普通のリンクとして通す */
        if (panel.hasAttribute('data-open')) {
          return;
        }

        event.preventDefault();
        open(hero, panel);
      });

      SMALL.addEventListener('change', function () {
        closeAll(hero);
      });

      watchLabel(hero);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup(document);
    });
  } else {
    setup(document);
  }

  /*
    ファーストビューを抜ける送り。実装仕様 #10〜#13
  */
  var passing = false;

  /* CSSの時間をミリ秒に。配信中のCSSは圧縮で 1200ms が 1.2s になる */
  function toMs(value, fallback) {
    var text = String(value || '').trim();
    var number = parseFloat(text);

    if (isNaN(number)) {
      return fallback;
    }

    return /ms$/.test(text) ? number : /s$/.test(text) ? number * 1000 : number;
  }

  /* --motion-ease（easeOutQuint）に近い曲線 */
  function easeOut(t) {
    return 1 - Math.pow(1 - t, 5);
  }

  /* 次のセクションの上端が、貼り付いたヘッダーの下に来る位置 */
  function passTarget(hero) {
    var section = hero.closest('.shopify-section') || hero;
    var next = section.nextElementSibling;
    var header = document.querySelector('.c-header');

    if (!next) {
      return null;
    }

    var bar = header ? header.getBoundingClientRect().bottom : 0;

    return Math.max(0, Math.round(next.getBoundingClientRect().top + window.scrollY - bar));
  }

  function pass(goal) {
    var duration = toMs(getComputedStyle(document.documentElement).getPropertyValue('--motion-duration'), 1200);
    var lenis = window.cSmoothScroll;

    passing = true;

    function done() {
      window.setTimeout(function () {
        passing = false;
      }, PASS_HOLD);
    }

    if (lenis && typeof lenis.scrollTo === 'function') {
      lenis.scrollTo(goal, { duration: duration / 1000, easing: easeOut, lock: true, force: true, onComplete: done });
      return;
    }

    window.scrollTo({ top: goal, behavior: 'smooth' });
    window.setTimeout(done, duration);
  }

  function stop(event) {
    if (event.cancelable) {
      event.preventDefault();
    }

    event.stopImmediatePropagation();
  }

  function onWheel(event) {
    if (!PASS.matches || MOTION.matches || event.ctrlKey) {
      return;
    }

    if (passing) {
      stop(event);
      return;
    }

    if (!event.deltaY || Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
      return;
    }

    var hero = document.querySelector('[data-c-tech-hero]');

    if (!hero || document.documentElement.classList.contains('lock-all')) {
      return;
    }

    if (event.target && event.target.closest && event.target.closest('[data-lenis-prevent], dialog')) {
      return;
    }

    var target = passTarget(hero);

    if (target === null || target < 2) {
      return;
    }

    var y = window.scrollY;
    var goal = null;

    if (event.deltaY > 0 && y < target - 1) {
      goal = target;
    } else if (event.deltaY < 0 && y > 1 && y <= target + 1) {
      goal = 0;
    }

    if (goal === null) {
      return;
    }

    stop(event);
    pass(goal);
  }

  window.addEventListener('wheel', onWheel, { passive: false, capture: true });

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
